"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactsRestService = exports.contactsRestService = exports.AuthorizationRestService = exports.authorizationRestService = exports.MessagesRestService = exports.messagesRestService = exports.UnrecognizedDocumentsRestService = exports.unrecognizedDocumentsRestService = exports.MeetingBulletinRestService = exports.meetingBulletinRestService = exports.KibanaRestService = exports.kibanaRestService = exports.UserRestService = exports.userRestService = exports.UsersRestService = exports.usersRestService = exports.DadataService = exports.dadataService = exports.RegistrationService = exports.registrationService = exports.RegistryOrderService = exports.registryOrderService = exports.SearchService = exports.searchService = exports.HTTPRequestError = exports.BaseRestService = void 0;
var BaseRestService_1 = require("./BaseRestService");
Object.defineProperty(exports, "BaseRestService", {
  enumerable: true,
  get: function () {
    return __importDefault(BaseRestService_1).default;
  }
});
Object.defineProperty(exports, "HTTPRequestError", {
  enumerable: true,
  get: function () {
    return BaseRestService_1.HTTPRequestError;
  }
});
var SearchService_1 = require("./search/SearchService");
Object.defineProperty(exports, "searchService", {
  enumerable: true,
  get: function () {
    return __importDefault(SearchService_1).default;
  }
});
Object.defineProperty(exports, "SearchService", {
  enumerable: true,
  get: function () {
    return SearchService_1.SearchService;
  }
});
var RegistryOrderService_1 = require("./registry/RegistryOrderService");
Object.defineProperty(exports, "registryOrderService", {
  enumerable: true,
  get: function () {
    return __importDefault(RegistryOrderService_1).default;
  }
});
Object.defineProperty(exports, "RegistryOrderService", {
  enumerable: true,
  get: function () {
    return RegistryOrderService_1.RegistryOrderService;
  }
});
var RegistrationService_1 = require("./registration/RegistrationService");
Object.defineProperty(exports, "registrationService", {
  enumerable: true,
  get: function () {
    return __importDefault(RegistrationService_1).default;
  }
});
Object.defineProperty(exports, "RegistrationService", {
  enumerable: true,
  get: function () {
    return RegistrationService_1.RegistrationService;
  }
});
var DadataService_1 = require("./dadata/DadataService");
Object.defineProperty(exports, "dadataService", {
  enumerable: true,
  get: function () {
    return __importDefault(DadataService_1).default;
  }
});
Object.defineProperty(exports, "DadataService", {
  enumerable: true,
  get: function () {
    return DadataService_1.DadataService;
  }
});
var UsersRestService_1 = require("./users/UsersRestService");
Object.defineProperty(exports, "usersRestService", {
  enumerable: true,
  get: function () {
    return __importDefault(UsersRestService_1).default;
  }
});
Object.defineProperty(exports, "UsersRestService", {
  enumerable: true,
  get: function () {
    return UsersRestService_1.UsersRestService;
  }
});
var UserRestService_1 = require("./user/UserRestService");
Object.defineProperty(exports, "userRestService", {
  enumerable: true,
  get: function () {
    return __importDefault(UserRestService_1).default;
  }
});
Object.defineProperty(exports, "UserRestService", {
  enumerable: true,
  get: function () {
    return UserRestService_1.UserRestService;
  }
});
var KibanaRestService_1 = require("./kibana/KibanaRestService");
Object.defineProperty(exports, "kibanaRestService", {
  enumerable: true,
  get: function () {
    return __importDefault(KibanaRestService_1).default;
  }
});
Object.defineProperty(exports, "KibanaRestService", {
  enumerable: true,
  get: function () {
    return KibanaRestService_1.KibanaRestService;
  }
});
__exportStar(require("./changeHistory/index"), exports);
var MeetingBulletinRestService_1 = require("./meetings/MeetingBulletinRestService");
Object.defineProperty(exports, "meetingBulletinRestService", {
  enumerable: true,
  get: function () {
    return __importDefault(MeetingBulletinRestService_1).default;
  }
});
Object.defineProperty(exports, "MeetingBulletinRestService", {
  enumerable: true,
  get: function () {
    return MeetingBulletinRestService_1.MeetingBulletinRestService;
  }
});
var UnrecognizedDocumentsRestService_1 = require("./meetings/UnrecognizedDocumentsRestService");
Object.defineProperty(exports, "unrecognizedDocumentsRestService", {
  enumerable: true,
  get: function () {
    return __importDefault(UnrecognizedDocumentsRestService_1).default;
  }
});
Object.defineProperty(exports, "UnrecognizedDocumentsRestService", {
  enumerable: true,
  get: function () {
    return UnrecognizedDocumentsRestService_1.UnrecognizedDocumentsRestService;
  }
});
var MessagesRestService_1 = require("./messages/MessagesRestService");
Object.defineProperty(exports, "messagesRestService", {
  enumerable: true,
  get: function () {
    return __importDefault(MessagesRestService_1).default;
  }
});
Object.defineProperty(exports, "MessagesRestService", {
  enumerable: true,
  get: function () {
    return MessagesRestService_1.MessagesRestService;
  }
});
var AuthorizationRestService_1 = require("./authorization/AuthorizationRestService");
Object.defineProperty(exports, "authorizationRestService", {
  enumerable: true,
  get: function () {
    return __importDefault(AuthorizationRestService_1).default;
  }
});
Object.defineProperty(exports, "AuthorizationRestService", {
  enumerable: true,
  get: function () {
    return AuthorizationRestService_1.AuthorizationRestService;
  }
});
var ContactsRestService_1 = require("./contacts/ContactsRestService");
Object.defineProperty(exports, "contactsRestService", {
  enumerable: true,
  get: function () {
    return __importDefault(ContactsRestService_1).default;
  }
});
Object.defineProperty(exports, "ContactsRestService", {
  enumerable: true,
  get: function () {
    return ContactsRestService_1.ContactsRestService;
  }
});
__exportStar(require("./contactForm"), exports);